import { render } from "./shippingView.vue?vue&type=template&id=950e1904&scoped=true"
import script from "./shippingView.vue?vue&type=script&lang=js"
export * from "./shippingView.vue?vue&type=script&lang=js"

import "./shippingView.vue?vue&type=style&index=0&id=950e1904&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-950e1904"]])

export default __exports__